import React from "react";
import { UserInfo } from "@cmp-src/components/UserInfo/UserInfo";
import { ResStatusIconNo } from "@cmp-src/icons/TacticIcons/ResStatusIconNo";
import { ResStatusIconUnknown } from "@cmp-src/icons/TacticIcons/ResStatusIconUnknown";
import { ResStatusIconYes } from "@cmp-src/icons/TacticIcons/ResStatusIconYes";
import { ExtendedInvitation } from "../DashboardMeetingAttendees/DashboardEventAttendees";
import {
  PRESENCE_STATUS_ACCEPTED,
  PRESENCE_STATUS_REJECTED,
  PRESENCE_STATUS_PENDING,
  ISlot
} from "@gettactic/api";

const PossibleAnswers = {
  [PRESENCE_STATUS_ACCEPTED]: ResStatusIconYes,
  [PRESENCE_STATUS_REJECTED]: ResStatusIconNo,
  [PRESENCE_STATUS_PENDING]: ResStatusIconUnknown
} as Record<
  ExtendedInvitation["presence_status"],
  React.FC<React.SVGProps<SVGSVGElement>>
>;

/** The answer each status icon stands for, read out instead of the icon. */
const ANSWER_LABELS: Record<ExtendedInvitation["presence_status"], string> = {
  [PRESENCE_STATUS_ACCEPTED]: "Coming",
  [PRESENCE_STATUS_REJECTED]: "Not coming",
  [PRESENCE_STATUS_PENDING]: "Not answered yet"
};

export type UserOnMeetingTileProps = {
  slot: ISlot;
};

/** An invitee with their answer (coming, not coming, not answered) on the avatar. */
export const UserOnMeetingTile = ({ slot }: UserOnMeetingTileProps) => {
  const user = {
    name: slot.user.name,
    profile_photo_url: slot.user.profile_photo_url,
    title: slot.user.title
  };
  const answer = slot.presence_status;

  return (
    <UserInfo
      badge={
        <div className="-top-1 -right-1 absolute z-10">
          {React.createElement(PossibleAnswers[answer], {
            role: "img",
            "aria-label": ANSWER_LABELS[answer]
          })}
        </div>
      }
      name={user.name || ""}
      profile_photo_url={user.profile_photo_url || undefined}
      title={user.title}
    />
  );
};
